export interface ITocSection {
  id: string;
  sectionNumber: string;
  sectionLabel: string;
  order: number;
}
/**
 * Type guard that asserts whether a value conforms to the ITocSection shape.
 *
 * @param obj - The object to check
 * @returns boolean
 */
export const isITocSection = (obj: unknown): obj is ITocSection => {
  // Check object
  if (typeof obj !== "object" || obj === null) return false;
  // Check properties exist
  const chkObj = obj as ITocSection;
  if (typeof chkObj.id !== "string") return false;
  if (typeof chkObj.sectionNumber !== "string") return false;
  if (typeof chkObj.sectionLabel !== "string") return false;
  if (typeof chkObj.order !== "number") return false;
  // Everything is good
  return true;
};
